import React from "react";
import clsx from "clsx";
import { Check } from "lucide-react";

interface QuoteRadioProps {
  checked: boolean;
  disabled?: boolean;
  name?: string;
  value: string;
  onChange?: () => void;
}

export const QuoteRadio: React.FC<QuoteRadioProps> = ({
  checked,
  disabled = false,
  name = "selectedQuote",
  value,
  onChange,
}) => (
  <label
    className={clsx(
      "relative flex h-6 w-6 shrink-0 items-center justify-center",
      disabled ? "cursor-not-allowed" : "cursor-pointer"
    )}
  >
    <input
      type="radio"
      name={name}
      value={value}
      checked={checked}
      disabled={disabled}
      onChange={onChange}
      className="peer sr-only"
    />
    <span
      className={clsx(
        "flex h-5 w-5 items-center justify-center rounded-full border-2 transition-all",
        disabled
          ? "border-[#D9D9D9] bg-white"
          : checked
          ? "border-[#2B63E1] bg-[#2B63E1]"
          : "border-[#C8C8C8] bg-white peer-hover:border-[#2B63E1]"
      )}
    >
      {checked && !disabled ? <Check className="h-3 w-3 text-white" strokeWidth={3} /> : null}
    </span>
  </label>
);
